import { GroupCartItem } from '~/types';
import sumBy from 'lodash/sumBy';
import calcCartItemsPrice from './calcCartItemsPrice';

export default function calcGroupCartItemsPrice(groupCartItems: Array<GroupCartItem>) {
  return sumBy(groupCartItems, ({ items }) => calcCartItemsPrice(items));
}
